import React from "react";

import { useIntl } from "react-intl";

import MapFilter, { getMapFilterDisplayName } from "../../enums/MapFilter";

import styles from "./BaseMapFilter.module.scss";
import BaseMapFilterProps from "./BaseMapFilterProps";
import FilterItem from "./FilterItem";

const filterList = [
  MapFilter.COMPLETED_ACTIVITIES,
  MapFilter.AUTO_ACTIVITIES,
  MapFilter.UPCOMING_ACTIVITIES,
  MapFilter.OVERDUE_ACTIVITIES,
  MapFilter.COMPANIES_OVER_CADENCE,
  MapFilter.COMPANIES_30_DAYS_NO_CONTACT,
  MapFilter.PEOPLE_OVER_CADENCE,
  MapFilter.PEOPLE_30_DAYS_NO_CONTACT,
];

interface Props extends BaseMapFilterProps {
  checkInFieldsVisibility: boolean;
}

const ActivitiesMapFilter: React.FC<Props> = ({
  checkInFieldsVisibility,
  filter,
  onChange,
  onDownload,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      {filterList
        .filter((option) => option !== MapFilter.AUTO_ACTIVITIES || checkInFieldsVisibility)
        .map((option) => (
          <FilterItem
            currentFilter={filter}
            filter={option}
            key={option}
            onClick={onChange}
            onDownloadClick={onDownload}
            title={getMapFilterDisplayName(intl, option)}
          />
        ))}
    </div>
  );
};

export default ActivitiesMapFilter;
